import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import { formatClock } from './alarmFormat';
import './alarm.css';

/* 알람 토스트 스택 — PNG 시안「알람 토스트 스택」. 헤더 아래 우상단에 새 알람이 쌓인다.
 * 심각도별 왼쪽 띠(CRITICAL 빨강 / WARNING 노랑 / INFO 파랑), 배지 + 시각, "설비 · 메시지", 공장명,
 * CRITICAL 은 "설비 상세 보기"(사출기 대시보드 알람 탭), 그 외는 "확인"(ACK). 데이터는 컨텍스트가 props 로 준다. */

const MAX_VISIBLE = 5;

function AlarmToastStack({ toasts, onClose, onAck, onOpenDetail }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!toasts || toasts.length === 0) return null;

  const goEquipment = (alarm) => {
    onClose(alarm.key);
    navigate('/machine', { state: { machineData: { id: alarm.equipmentId, name: alarm.equipmentName }, openTab: 'alarm', alarmId: alarm.code } });
  };

  return ReactDOM.createPortal(
    <div className="al-toast-stack">
      {toasts.slice(0, MAX_VISIBLE).map((alarm) => (
        <div key={alarm.key} className={`al-toast al-sev-${alarm.severity.toLowerCase()}`} role="status">
          <div className="al-toast-head">
            <span className={`al-badge al-badge-${alarm.severity.toLowerCase()}`}>{alarm.severity}</span>
            <span className="al-toast-time">{formatClock(alarm.at)}</span>
            <button type="button" className="al-icon-btn" onClick={() => onClose(alarm.key)} title={t('common.close')} aria-label={t('common.close')}>
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
          <button type="button" className="al-toast-title" onClick={() => { onClose(alarm.key); onOpenDetail(alarm); }}>
            {alarm.equipmentName} · {alarm.message || alarm.code}
          </button>
          <div className="al-toast-foot">
            <span className="al-toast-meta">{alarm.factoryName || '—'}</span>
            {alarm.severity === 'CRITICAL'
              ? <button type="button" className="al-link al-link-error" onClick={() => goEquipment(alarm)}>{t('header.toast.detail')}</button>
              : <button type="button" className="al-link" onClick={() => onAck(alarm.key)}>{t('header.toast.ack')}</button>}
          </div>
        </div>
      ))}
    </div>,
    document.body
  );
}

export default AlarmToastStack;
